<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 justify-center>
        <v-card style="padding: 8px; border-radius: 12px;">
          <v-card-title class="font-weight-bold headline">
            Setup Code
          </v-card-title>
          <v-card-text>
            Enter your provided Setup Code to get access to the products you
            need.
          </v-card-text>

          <v-text-field
            v-model="setupCode"
            label="Your Setup Code"
            v-mask="mask"
            placeholder="XXXX-XXXX-XXXX-XXXX"
            prepend-icon="vpn_key"
            outline
          ></v-text-field>
          <v-alert :value="show_alert" :type="alert_type">{{
            alert_text
          }}</v-alert>
          <v-progress-linear
            v-if="show_loading"
            :indeterminate="true"
          ></v-progress-linear>
          <v-card-actions>
            <v-btn
              v-on:click="checkSetupCode"
              :disabled="show_loading"
              block
              rounded
              class="primary"
            >
              Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout></v-container
  >
</template>

<script>
import { mask } from "vue-the-mask";
/* global firebase */
export default {
  name: "Profile",
  directives: {
    mask
  },
  data() {
    return {
      mask: "AAAA-AAAA-AAAA-AAAA",
      setupCode: "",
      show_alert: false,
      alert_type: "success",
      alert_text: "",
      show_loading: false
    };
  },
  methods: {
    async checkSetupCode() {
      this.show_loading = true;
      this.show_alert = false;

      const code = this.setupCode;
      let params = { setupCode: code };
      let callable = firebase
        .app()
        .functions("europe-west1")
        .httpsCallable("Setup_Code_Verification");

      callable(params)
        .then(result => {
          this.show_loading = false;
          if (result.data.done) {
            this.show_alert = true;
            this.alert_type = "success";
            this.alert_text = "Setup Code was applied successfully!";
          } else {
            this.show_alert = true;
            this.alert_type = "error";
            this.alert_text = "Setup Code could not be validated!";
          }
        })
        .catch(() => {
          this.show_loading = false;
          this.show_alert = true;
          this.alert_type = "error";
          this.alert_text = "Setup Code could not be validated!";
        });
    }
  }
};
</script>

<style scoped></style>
